<template lang="pug">
  .form-user
    .columns.is-multiline
      .column.is-4-tablet.is-4-desktop
        b-field(label="Дата начала доступности материала")
          datepicker(v-model="value.start_date")

      .column.is-4-tablet.is-4-desktop
        b-field(label="Дата окончания доступности материала")
          datepicker(v-model="value.end_date")

    .columns.is-multiline
      .column.is-6-tablet.is-6-desktop

        ui-field(label="Название материала" v-model="value.name" :error="errors.name" rules="required")

        ui-field(type="textarea" label="Описание" v-model="value.description" :error="errors.description")

        ui-field(
          type="select"
          v-model="value.category_id"
          :error="errors.category_id"
          label="Категория материала"
          rules=""
        )
          option(:value="0")
          option(v-for="{id, name} in this.categories.items" :value="id" :key="id") {{ name }}

        b-field(label="Минимальное время просмотра")
          timepicker(v-model="value.minimal_viewing_time")

</template>

<script>
import Category from '@/models/Category';

export default {
  name: 'form-lesson',

  props: {
    value: null,
    errors: { type: Object, default: () => ({}) },
  },

  data: () => ({
    categories: Category.collection(),
  }),

  created() {
    this.categories.$fetch();
  },
};
</script>
